import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { message, Spin, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import Instance from "../../AxiosConfig";

const { Dragger } = Upload;

const AddVendorModal = ({ show, handleClose, fetchData }) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    vendorName: "",
    businessName: "",
    gst: "",
    pan: "",
    contactPerson: "",
    email: "",
    mobile: "",
    address: "",
    bankDetails: "",
    accreditations: "",
    documents: null,
    samples: null,
    content: "",
  });

  const [errors, setErrors] = useState({});

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Upload handler
  const uploadProps = (fieldName) => ({
    beforeUpload: (file) => {
      setFormData((prev) => ({
        ...prev,
        [fieldName]: file,
      }));
      return false; // prevent auto upload
    },
    maxCount: 1,
  });

  // Validation
  const validate = () => {
    let newErrors = {};

    if (!formData.vendorName) newErrors.vendorName = "Vendor Name is required";
    if (!formData.businessName) newErrors.businessName = "Business Name is required";
    if (!formData.contactPerson) newErrors.contactPerson = "Contact Person is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile) newErrors.mobile = "Mobile is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.bankDetails) newErrors.bankDetails = "Bank details are required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Save
  const handleSave = async () => {
    if (!validate()) return;

    // try {
    //   setLoading(true);

    //   const formDataToSend = new FormData();

    //   Object.keys(formData).forEach((key) => {
    //     if (formData[key]) {
    //       formDataToSend.append(key, formData[key]);
    //     }
    //   });

    //   const response = await Instance.post("/vendors", formDataToSend, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   });

    //   if (response.status === 200 || response.status === 201) {
    //     message.success("Vendor added successfully!");
    //     handleClose();

    //     setFormData({
    //       vendorName: "",
    //       businessName: "",
    //       gst: "",
    //       pan: "",
    //       contactPerson: "",
    //       email: "",
    //       mobile: "",
    //       address: "",
    //       bankDetails: "",
    //       accreditations: "",
    //       documents: null,
    //       samples: null,
    //       content: "",
    //     });

    //     fetchData();
    //   }
    // } catch (error) {
    //   console.error(error);
    //   message.error("Failed to add vendor");
    // } finally {
    //   setLoading(false);
    // }
  };

  const renderError = (field) =>
    errors[field] && <small className="text-danger">{errors[field]}</small>;

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Add New Vendor</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container-fluid">
          <div className="row">

            {/* Vendor Name */}
            <div className="col-md-6 mb-3">
              <label>Vendor Name *</label>
              <input
                type="text"
                name="vendorName"
                value={formData.vendorName}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter vendor name"
              />
              {renderError("vendorName")}
            </div>

            {/* Business Name */}
            <div className="col-md-6 mb-3">
              <label>Business Entity Name *</label>
              <input
                type="text"
                name="businessName"
                value={formData.businessName}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter business entity name"
              />
              {renderError("businessName")}
            </div>

            {/* GST */}
            <div className="col-md-6 mb-3">
              <label>GST Number</label>
              <input
                type="text"
                name="gst"
                value={formData.gst}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter GST number"
              />
            </div>

            {/* PAN */}
            <div className="col-md-6 mb-3">
              <label>PAN Number</label>
              <input
                type="text"
                name="pan"
                value={formData.pan}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter PAN number"
              />
            </div>

            {/* Contact Person */}
            <div className="col-md-6 mb-3">
              <label>Contact Person *</label>
              <input
                type="text"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter contact person name"
              />
              {renderError("contactPerson")}
            </div>

            {/* Email */}
            <div className="col-md-6 mb-3">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter email address"
              />
              {renderError("email")}
            </div>

            {/* Mobile */}
            <div className="col-md-6 mb-3">
              <label>Mobile *</label>
              <input
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter mobile number"
              />
              {renderError("mobile")}
            </div>

            {/* Address */}
            <div className="col-md-12 mb-3">
              <label>Address *</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter full address"
              />
              {renderError("address")}
            </div>

            {/* Bank Details */}
            <div className="col-md-12 mb-3">
              <label>Bank Details *</label>
              <textarea
                name="bankDetails"
                value={formData.bankDetails}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter bank details"
              />
              {renderError("bankDetails")}
            </div>

            {/* Accreditations */}
            <div className="col-md-12 mb-3">
              <label>Accreditations</label>
              <input
                type="text"
                name="accreditations"
                value={formData.accreditations}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter accreditations"
              />
            </div>

            {/* Documents Upload */}
            <div className="col-md-12 mb-5">
              <label>Documents Upload</label>
              <Dragger {...uploadProps("documents")}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to upload documents
                </p>
                <p className="ant-upload-hint">
                  Upload PDF, Image, etc.
                </p>
              </Dragger>
            </div>

            {/* Samples Upload */}
            <div className="col-md-12 mb-5">
              <label>Samples Upload</label>
              <Dragger {...uploadProps("samples")}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag sample files here
                </p>
                <p className="ant-upload-hint">
                  Upload sample files
                </p>
              </Dragger>
            </div>

            {/* Content */}
            <div className="col-md-12 mb-3">
              <label>Content</label>
              <textarea
                name="content"
                value={formData.content}
                onChange={handleChange}
                className="form-control"
                placeholder="Enter additional notes"
              />
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end gap-2 mt-3">
              <button className="users-discard-button" onClick={handleClose}>
                Discard
              </button>

              <button
                className="users-save-button d-flex align-items-center justify-content-center"
                onClick={handleSave}
                disabled={loading}
                style={{ minWidth: "120px" }}
              >
                {loading ? (
                  <>
                    <Spin size="small" /> &nbsp;Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>

          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddVendorModal;